/* istanbul ignore file */
export { default } from './FullWidthContainer';
